// const debug = require('debug')('OD::Store:Style')

const state = {
  style: {
    section: {
      color: 'blue-grey darken-4',
      dark: true,
    },
    primary: 'blue-grey darken-1',
  },
}

const getters = {}

const mutations = {}

const actions = {}

export default { namespaced: true, state, mutations, actions, getters }
